import { render, staticRenderFns } from "./PerManagement.vue?vue&type=template&id=6b466440&scoped=true"
import script from "./PerManagement.vue?vue&type=script&lang=js"
export * from "./PerManagement.vue?vue&type=script&lang=js"
import style0 from "./PerManagement.vue?vue&type=style&index=0&id=6b466440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b466440",
  null
  
)

export default component.exports